import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import { defaultSeasonPoolExportFieldNames } from "~pages/SeasonPools/SeasonPoolListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSeasonPools = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/pools/export`, {
        method: "POST",
        body: {
          fieldNames: fieldNames || defaultSeasonPoolExportFieldNames,
        },
      }),
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success) {
        notification.success({
          message: formatMessage({ id: "seasonPools.export.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
